import handleCallback from "../helper/APICallback";
import APIService from "./apiService";
import AuthService from "./authService";
import ObjectToQueryParams from "./ObjectToQueryParams";
const API = AuthService.getRemoteURL();
const PRODUCTS_API = {
  getProducts(options) {
    const query = ObjectToQueryParams(options);
    return new Promise((resolve, reject) => {
      APIService.request(
        {
          url: `${API}/api/v1/POS/merchant/on-table/menu/v1/${query}`,
          method: "GET",
        },
        handleCallback(resolve, reject)
      );
    });
  },
  placeYourOrder(merchantId, storeId) {
    return new Promise((resolve, reject) => {
      APIService.request(
        {
          url: `${API}/api/v1/POS/merchant/on-table/menu?merchantId=${merchantId}&storeId=${storeId}`,
          method: "GET",
        },
        handleCallback(resolve, reject)
      );
    });
  },

  getAddonsById(productId) {
    return new Promise((resolve, reject) => {
      APIService.request(
        {
          url: `${API}/api/v1/POS/merchant/product-addons?productId=${productId}`,
          method: "GET",
        },
        handleCallback(resolve, reject)
      );
    });
  },
  checkStock(options) {
    return new Promise((resolve, reject) => {
      APIService.request(
        {
          url: `${API}/api/v1/POS/merchant/stock-check`,
          method: "POST",
          data: JSON.stringify(options),
        },
        handleCallback(resolve, reject)
      );
    });
  },
  appendTableOrder({ data, tableId }) {
    return new Promise((resolve, reject) => {
      APIService.request(
        {
          url: `${API}/api/v1/POS/merchant/tableOrder/append-table-orders/${tableId}`,
          method: "POST",
          data: JSON.stringify(data),
        },
        handleCallback(resolve, reject)
      );
    });
  },
  getStatus(paymentId) {
    return new Promise((resolve, reject) => {
      APIService.request(
        {
          url: `${API}/api/v1/POS/merchant/on-table/order-status?paymentId=${paymentId}`,
          method: "GET",
        },
        handleCallback(resolve, reject)
      );
    });
  },
  getPaymentStatus(options) {
    return new Promise((resolve, reject) => {
      APIService.request(
        {
          url: `${API}/api/v1/POS/merchant/on-table/verify-payment/local/v1`,
          method: "POST",
          data: JSON.stringify(options),
        },
        handleCallback(resolve, reject)
      );
    });
  },
  cancelPaymentOrder(options) {
    return new Promise((resolve, reject) => {
      APIService.request(
        {
          url: `${API}/api/v1/POS/merchant/on-table/cancel-order/v1`,
          method: "POST",
          data: JSON.stringify(options),
        },
        handleCallback(resolve, reject)
      );
    });
  },
  verifyPaymentStatus(data) {
    return new Promise((resolve, reject) => {
      APIService.request(
        {
          url: `${API}/api/v1/POS/merchant/on-table/verify-payment/v1`,
          method: "POST",
          data: JSON.stringify(data),
        },
        handleCallback(resolve, reject)
      );
    });
  },
  verifyPaymentStatusLocal(data) {
    return new Promise((resolve, reject) => {
      APIService.request(
        {
          url: `${API}/api/v1/POS/merchant/on-table/verify-payment/local/v1`,
          method: "POST",
          data: JSON.stringify(data),
        },
        handleCallback(resolve, reject)
      );
    });
  },
  cancelOrder(data) {
    return new Promise((resolve, reject) => {
      APIService.request(
        {
          url: `${API}/api/v1/POS/merchant/on-table/cancel-order/v1`,
          method: "POST",
          data: JSON.stringify(data),
        },
        handleCallback(resolve, reject)
      );
    });
  },
  getOrderDetails(params) {
    const query = ObjectToQueryParams(params);
    return new Promise((resolve, reject) => {
      APIService.request(
        {
          url: `${API}/api/v1/POS/merchant/on-table/order-items/v1${query}`,
          method: "GET",
        },
        handleCallback(resolve, reject)
      );
    });
  },
  getEbillConfiguration(options) {
    return new Promise((resolve, reject) => {
      APIService.request(
        {
          url: `${API}/api/v1/POS/merchant/stores/ebill-info?storeId=${options?.storeId}&terminalId=${options?.terminalId}&merchantId=${options?.merchantId}`,
          method: "GET",
        },
        handleCallback(resolve, reject)
      );
    });
  },
  // getEbillConfiguration(options) {
  //   return new Promise((resolve, reject) => {
  //     APIService.request(
  //       {
  //         url: `${API}/api/v1/POS/merchant/stores/ebill-settings?storeId=${options?.storeId}&terminalId=${options?.terminalId}`,
  //         method: "GET",
  //       },
  //       handleCallback(resolve, reject)
  //     );
  //   });
  // },
  getConfiguration(options) {
    const query = ObjectToQueryParams(options);
    return new Promise((resolve, reject) => {
      APIService.request(
        {
          url: `${API}/api/v1/POS/merchant/on-table/scanQr-settings${query}`,
          method: "GET",
        },
        handleCallback(resolve, reject)
      );
    });
  },
};
export default PRODUCTS_API;
